<template>
    <defaultSec>
        <template #title>
            <div  class="default-header" style="display: flex;justify-content: space-between">
                <h3 style="cursor: pointer">反馈详情</h3>
            </div>

        </template>
        <div class="work-order-detail-info" v-loading="loading">
            <el-alert style="margin: 0 0 10px 0"
                      title="反馈信息"
                      type="success"
                      :closable="false">
            </el-alert>
            <el-descriptions class="margin-top" :label-style="labelStyle" :column="1" size="small" border>

                <el-descriptions-item label="用户问题">
                    {{userFeedBackForm.user}}
                </el-descriptions-item>
                <el-descriptions-item label="AI回复">
                    {{userFeedBackForm.assistant}}
                </el-descriptions-item>
                <el-descriptions-item label="评分">
                    <el-rate
                        v-model="userFeedBackForm.rating"
                        show-text>
                    </el-rate>
                </el-descriptions-item>
                <el-descriptions-item label="反馈内容">
                    <el-input type="textarea" style="width: 100%" size="small" v-model="userFeedBackForm.feedbackText" placeholder="请输入" />
                </el-descriptions-item>
                <el-descriptions-item label="标准答案">
                    <el-input type="textarea" style="width: 100%" size="small" v-model="userFeedBackForm.moduleAnswer" placeholder="请输入" />
                </el-descriptions-item>
                <el-descriptions-item label="操作">
                    <el-button type="danger" size="small" @click="addUserFeedback">保存</el-button>
                </el-descriptions-item>

            </el-descriptions>
            <el-alert style="margin: 20px 0 10px 0"
                      title="历史填写"
                      type="success"
                      :closable="false">
            </el-alert>
            <el-table size="mini" border :data="feedBackList" style="width: 100%">
                <el-table-column type="index" label="序号" width="70"></el-table-column>
                <el-table-column prop="feedbackTime" label="反馈时间" width="180">
                    <template slot-scope="scope">
                        {{new Date(scope.row.feedbackTime).Format("yyyy-MM-dd hh:mm:ss")}}
                    </template>
                </el-table-column>
                <el-table-column label="评分" width="180">
                    <template slot-scope="scope">
                        <el-rate
                            disabled
                            v-model="scope.row.rating"
                            :texts="['极差','差','一般','满意','非常满意']"
                            show-text>
                        </el-rate>
                    </template>
                </el-table-column>
                <el-table-column prop="feedbackText" label="反馈内容"></el-table-column>
                <el-table-column prop="moduleAnswer" label="标准答案"></el-table-column>
            </el-table>
        </div>
    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'
export default {
    data() {
        return {
            loading:false,
            messageId:this.$route.query.messageId,
            userFeedBackForm:{
                user:'',
                assistant:'',
            },
            feedBackList:[],
            labelStyle:{
                width: '100px',
            },

        }
    },
    components:{
        defaultSec,
    },
    mounted(){
        this.loading = true
        this.initList()
        this.initFeedBackList()
    },
    methods: {
        initList() {
            this.$apiGet('lechun-ai/chat/getMessageMap',{ messageId: this.messageId}).then(res => {
                this.loading = false
                this.userFeedBackForm = res

            });

        },
        initFeedBackList() {
            this.$apiGet('lechun-ai/chat/getUserFeedback',{ messageId: this.messageId}).then(res => {
                this.loading = false
                this.feedBackList = res

            });

        },
        addUserFeedback(){
            let {assistant,user,...param} = {...this.userFeedBackForm}
            console.log(11,this.userFeedBackForm)
            param.messageId = this.messageId
            this.$apiPost('lechun-ai/chat/addUserFeedback', {...param}).then(res => {
                console.log(res)
                this.$message({
                    message: '成功',
                    type: 'success',
                });
                this.initFeedBackList()
            })
        },
    }
}
</script>


<style lang="scss">
.work-order-detail-info {

    .box-card{
        margin-bottom: 20px;
    }
    .el-card__header {
        padding: 10px;
    }

    .el-card__body {
        padding: 0 10px 20px;
    }

    .popover-title {
        margin: 0 0 15px 0;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100%;
    }

    .el-tag {
        margin-right: 10px;
    }
    .el-divider__text {
        color: #209e91;
    }
    .paste-wrap{
        width: 100px;
        height: 80px;
        border: 1px dashed #209e91;
        text-align: center;
        line-height: 80px;
    }
}
</style>
